module.exports = __webpack_public_path__ + "static/media/Fly_2x.e5d232f0.jpg";